// Composable takes a string and if it is a number formats it according to local standards
import { useProductsStore } from '@/app/stores/productsStore.js';

export function useValue(string) {
  const productsStore = useProductsStore();

  return (!isNaN(string) && parseFloat(string)) ? parseFloat(string).toLocaleString(productsStore.locales) : string;
}
